import MdsTable from './table.vue';
import MdsThead from './thead.vue';
import MdsTh from './th.vue';
import MdsTbody from './tbody.vue';
import MdsTr from './tr.vue';
import MdsTd from './td.vue';

export { MdsTable, MdsThead, MdsTh, MdsTbody, MdsTr, MdsTd };
